import type { CSSObjectWithLabel } from 'react-select'

import { BLUE, GREY } from '~/shared/lib/theme'

export const selectCustomStyles = {
  menuPortal: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: 9999,
  }),
  control: (base: CSSObjectWithLabel, state: { isFocused: boolean }) => ({
    backgroundColor: GREY[50],
    display: 'flex',
    fontSize: '1.6rem',
    height: '100%',
    borderBottom: `2px solid ${GREY[50]}`,
    borderColor: state.isFocused ? BLUE[500] : GREY[50],
  }),
  group: () => ({
    fontSize: '1.6rem',
  }),
  groupHeading: () => ({
    fontSize: '1.6rem',
    color: BLUE[600],
    margin: '1rem',
  }),
}
